import {isEmpty} from '../modules/appLibrary';

//追加登録ファイルアップロード
export function cfFileUpload(controller, code, files, fnc, callback) {
    let param = {
        "code": code,
        "count": files.length,
        "check": false
    };
    for (let i = 0; i < files.length; i++) {
        param["file" + (i + 1).toString()] = files[i];
    }
    let url = controller + "/Upload"
    fnc.current.fileupload(url, param,
        {
            onSuccess: function (data) {
                fnc.current.success();
                fnc.current.wait(false);
                callback();
            },
            onError: function (data) {
                fnc.current.wait(false);
                if (data.request === "") {
                    fnc.warnmessage(data.errDescription);
                    return;
                }
            }
        });
}

//新規登録関連ファイルを抽出
export function cfNewUploadFile(imageRef, fileRef) {
    var files = [];
    if (!isEmpty(imageRef.current)) {
        for (let i = 0; i < imageRef.current.length; i++) {
            if (!isEmpty(imageRef.current[i]["fileinfo"])) {
                files.push(imageRef.current[i]["fileinfo"]);
            }
        }
    }
    if (!isEmpty(fileRef.current)) {
        for (let i = 0; i < fileRef.current.length; i++) {
            if (!isEmpty(fileRef.current[i]["fileinfo"])) {
                files.push(fileRef.current[i]["fileinfo"]);
            }
        }
    }
    return files;
}

//新規アップロードファイルをRefにマージ
export function cfMargeUploadFiles(ref, files) {
    var duplicate = false;
    if (isEmpty(ref.current)) ref.current = [];
    var addfiles = [];
    for (let i = 0; i < files.length; i++) {    //アップロードファイルLoop
        if (ref.current.some(e => e.filename === files[i].filename)) {  //重複チェック
            duplicate = true;
        } else {
            addfiles.push(files[i]);
        }
    }
    ref.current = ref.current.concat(addfiles);    //重複を除いた新規分をRefとマージ
    return duplicate;
}

